import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Bell } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/notifications/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Notifiche</h1>
        <Button asChild>
          <Link to="/notifications/new">
            <Bell className="mr-2 h-4 w-4" />
            Nuova notifica
          </Link>
        </Button>
      </div>
    </div>
  )
}
